module.exports = {
    SERVER_ADDRESS: "https://kids-in-seats.herokuapp.com",
}
